import { render, staticRenderFns } from "./IdentityResourceDetailForm.vue?vue&type=template&id=219d8c0e&"
import script from "./IdentityResourceDetailForm.vue?vue&type=script&lang=js&"
export * from "./IdentityResourceDetailForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports